var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteriorDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.39,30.38c-0.54-0.09-2.74-0.48-3.29,0.03c-1.59,1.46-0.9,8.17-0.79,9.14c-9.12-1.12-23.51-1.12-32.62,0 c0.11-0.98,0.79-7.68-0.79-9.14c-0.55-0.51-2.76-0.12-3.29-0.03C16.48,27.35,33.51,27.35,45.39,30.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.31,40.03c-0.02,0-0.04,0-0.06,0c-9.12-1.12-23.39-1.12-32.5,0c-0.15,0.02-0.3-0.03-0.4-0.14 c-0.11-0.11-0.16-0.25-0.14-0.4c0.4-3.68,0.36-7.8-0.63-8.72c-0.02-0.01-0.42-0.33-2.87,0.1c-0.26,0.05-0.51-0.12-0.57-0.38 c-0.06-0.26,0.1-0.51,0.36-0.58c11.88-3.03,29.13-3.03,41.02,0c0.26,0.06,0.41,0.32,0.36,0.58c-0.06,0.26-0.3,0.42-0.56,0.38l0,0 c-2.45-0.43-2.85-0.11-2.87-0.1c-1.01,0.92-1.04,5.05-0.64,8.72c0.02,0.15-0.04,0.3-0.14,0.4C41.56,39.98,41.44,40.03,41.31,40.03 z M8.26,30.07c1.47,1.42,1.23,6.31,0.98,8.91c8.98-1.04,22.52-1.04,31.52,0c-0.25-2.6-0.5-7.48,0.98-8.91 C31.51,28.12,18.49,28.12,8.26,30.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.68,43.65H1.27L0.49,34.4c0,0,2.78-0.58,3.41,0C5.61,35.97,4.68,43.65,4.68,43.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.68,44.14H1.27c-0.25,0-0.47-0.2-0.49-0.45L0,34.44c-0.02-0.25,0.15-0.47,0.39-0.52 c0.91-0.19,3.11-0.55,3.84,0.12c1.84,1.69,1.03,8.85,0.93,9.67C5.13,43.95,4.93,44.14,4.68,44.14z M1.72,43.16h2.52 c0.31-2.91,0.39-7.43-0.67-8.39C3.36,34.58,2.2,34.6,1.02,34.8L1.72,43.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.51,34.4l-0.78,9.24h-3.41c0,0-0.94-7.68,0.78-9.24C46.73,33.83,49.51,34.4,49.51,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.73,44.14h-3.41c-0.25,0-0.46-0.18-0.49-0.43c-0.1-0.81-0.91-7.98,0.93-9.67 c0.73-0.67,2.93-0.31,3.84-0.12c0.24,0.05,0.41,0.27,0.39,0.52l-0.78,9.24C49.2,43.94,48.99,44.14,48.73,44.14z M45.76,43.16h2.52 l0.7-8.35c-1.18-0.2-2.34-0.23-2.56-0.04C45.37,35.73,45.45,40.25,45.76,43.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.72,43.65v1.89c0,0.68-0.55,1.23-1.23,1.23H2.5c-0.68,0-1.23-0.55-1.23-1.23v-1.89H48.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.49,47.25H2.5c-0.95,0-1.72-0.77-1.72-1.72v-1.89c0-0.27,0.22-0.49,0.49-0.49h47.45 c0.27,0,0.49,0.22,0.49,0.49v1.89C49.21,46.48,48.44,47.25,47.49,47.25z M1.76,44.14v1.4c0,0.41,0.33,0.74,0.74,0.74h44.99 c0.41,0,0.74-0.33,0.74-0.74v-1.4H1.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.69,39.54c-0.01,0.08-0.01,0.12-0.01,0.12l-4,3.99c0,0,0.94-7.68-0.78-9.24c-0.63-0.58-3.41,0-3.41,0l4-4 c0.04-0.01,0.08-0.03,0.12-0.03c0.54-0.09,2.74-0.48,3.29,0.03C9.48,31.86,8.8,38.56,8.69,39.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.68,44.14c-0.07,0-0.15-0.02-0.21-0.05c-0.19-0.09-0.3-0.29-0.27-0.5c0.35-2.87,0.49-7.81-0.62-8.82 c-0.24-0.21-1.66-0.15-2.98,0.12c-0.21,0.04-0.43-0.06-0.53-0.25c-0.1-0.19-0.07-0.43,0.08-0.58l4-4C4.2,30,4.26,29.96,4.33,29.94 c0.06-0.02,0.16-0.05,0.28-0.05c2.56-0.46,3.29-0.16,3.62,0.16c1.63,1.51,1.2,7.18,0.94,9.55c0,0.01,0,0.02,0,0.03l-0.01,0.05 c-0.01,0.12-0.06,0.25-0.14,0.33l-4,3.99C4.93,44.09,4.8,44.14,4.68,44.14z M2.67,33.65c0.65,0,1.24,0.1,1.56,0.39 c1.43,1.31,1.26,5.91,1.07,8.29l2.91-2.9c0.4-3.66,0.35-7.75-0.64-8.67c-0.02-0.01-0.41-0.33-2.83,0.09l-2.84,2.84 C2.15,33.67,2.42,33.65,2.67,33.65z M8.69,39.54L8.69,39.54L8.69,39.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.51,34.4c0,0-2.78-0.58-3.41,0c-1.71,1.57-0.78,9.24-0.78,9.24l-4-3.99c0,0,0-0.04-0.01-0.12 c-0.11-0.96-0.8-7.68,0.79-9.14c0.55-0.51,2.76-0.12,3.29-0.03c0.04,0,0.08,0.01,0.12,0.03L49.51,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.32,44.14c-0.13,0-0.25-0.05-0.35-0.14l-4-3.99c-0.09-0.09-0.14-0.22-0.14-0.35 c-0.27-2.44-0.71-8.11,0.94-9.62c0.34-0.31,1.06-0.61,3.7-0.15c0.04-0.01,0.14,0.03,0.2,0.05c0.07,0.02,0.14,0.06,0.19,0.12l4,4 c0.15,0.15,0.19,0.39,0.08,0.58c-0.1,0.19-0.32,0.29-0.53,0.25c-1.32-0.27-2.74-0.33-2.98-0.12c-1.11,1.02-0.97,5.95-0.62,8.82 c0.03,0.21-0.08,0.41-0.27,0.5C45.47,44.12,45.4,44.14,45.32,44.14z M41.79,39.44l2.91,2.9c-0.19-2.38-0.36-6.98,1.07-8.29 c0.45-0.41,1.43-0.43,2.34-0.35l-2.84-2.84c-2.43-0.42-2.82-0.1-2.83-0.09C41.43,31.68,41.39,35.77,41.79,39.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.32,43.65H4.68l4-3.99c0,0,0-0.04,0.01-0.12c9.11-1.12,23.49-1.12,32.62,0c0.01,0.08,0.01,0.12,0.01,0.12 L45.32,43.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.32,44.14H4.68c-0.2,0-0.38-0.12-0.45-0.3c-0.08-0.18-0.03-0.39,0.11-0.53l3.88-3.87 c0.05-0.2,0.21-0.35,0.42-0.38c9.17-1.13,23.55-1.13,32.74,0c0.21,0.03,0.37,0.18,0.42,0.38l3.88,3.87 c0.14,0.14,0.18,0.35,0.11,0.53C45.7,44.02,45.52,44.14,45.32,44.14z M5.86,43.16h38.27l-3.16-3.15c-0.01,0-0.01-0.01-0.01-0.02 c-9.03-1.08-22.9-1.08-31.92,0c0,0.01-0.01,0.01-0.01,0.02L5.86,43.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000022531687513251386960000008724852226123084166_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000173155913554762965370000000244313706500834698_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.37,46.55c-0.07,0.21-0.05,0.45,0.09,0.63l2.1,2.68c0.13,0.17,0.32,0.27,0.52,0.27h1.2 c0.37,0,0.67-0.31,0.67-0.67v-2.69c0-0.08-0.02-0.15-0.04-0.22H42.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.07,46.55c-0.02,0.07-0.04,0.14-0.04,0.22v2.69c0,0.36,0.29,0.67,0.67,0.67h1.2c0.2,0,0.4-0.09,0.52-0.27 l2.11-2.68c0.13-0.18,0.17-0.42,0.09-0.63H3.07z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.56,
    y: 14.93,
    className: "st1",
    width: 13.53,
    height: 1.42
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.7,
    y: 6.54,
    className: "st1",
    width: 1.92,
    height: 8.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.68,
    y: 6.54,
    className: "st1",
    width: 1.92,
    height: 8.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.77,
    y: 9.91,
    transform: "matrix(0.3415 -0.9399 0.9399 0.3415 14.0547 41.7949)",
    className: "st1",
    width: 8.17,
    height: 1.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.43,
    y: 2.6,
    className: "st0",
    width: 6.99,
    height: 8.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.78,2.16v9.43h8.27V2.16H16.78z M23.85,10.39h-5.86V3.36h5.86V10.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088104520062364051230000002295240338691839892_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.16,3.09c-0.13,0-0.25-0.05-0.35-0.14l-1.89-1.89l-1.89,1.89c-0.19,0.19-0.5,0.19-0.69,0 c-0.19-0.19-0.19-0.5,0-0.69l2.24-2.23c0.19-0.19,0.5-0.19,0.69,0l2.24,2.24c0.19,0.19,0.19,0.5,0,0.69 C23.41,3.05,23.28,3.09,23.16,3.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.49,6.96l-1.57,1.57l-1.57-1.57c-0.39-0.4-0.39-1.04,0-1.44c0.21-0.2,0.46-0.3,0.73-0.3 c0.25,0,0.52,0.11,0.72,0.3l0.13,0.13l0.13-0.13c0.2-0.2,0.46-0.3,0.72-0.3c0.26,0,0.53,0.11,0.73,0.3 C22.89,5.92,22.89,6.56,22.49,6.96z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.35,
    y: 7.55,
    className: "st0",
    width: 6.99,
    height: 14.71
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.57,6.88v15.9h8.63V6.88H3.57z M10.94,21.51H4.83V8.14h6.11V21.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000000945644549793527010000008093361171293577905_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.12,8.04c-0.13,0-0.25-0.05-0.35-0.14L7.89,6L6,7.89c-0.19,0.19-0.5,0.19-0.69,0 c-0.19-0.19-0.19-0.5,0-0.69l2.24-2.23c0.19-0.19,0.5-0.19,0.69,0l2.24,2.24c0.19,0.19,0.19,0.5,0,0.69 C10.37,7.99,10.25,8.04,10.12,8.04z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorDesign);
export default __webpack_public_path__ + "static/media/interior-design.256e9d0f10db0aa34677025002b42a56.svg";
export { ForwardRef as ReactComponent };